import { useMemo, useState } from "react";

export const useStateWithValidation = <T, R = boolean>(
  initialState: T,
  validator: (state: T) => R,
) => {
  const [state, setState] = useState<T>(initialState);
  const valid = useMemo(() => validator(state), [state, validator]);

  return [state, setState, valid] as const;
};
